<template>
  <section class="price">
    <div class="wrapper">
      <div class="price__description">
        <h2 class="price__title">{{ title }}</h2>
        <CTextBlock :text="text" />
      </div>
      <div class="price__spoilers">
        <CPriceItemBlock
          v-for="(price, index) in prices"
          :key="index"
          :index="index"
          :title="price.name"
          :text="price.text"
          :price="price.price"
          :services="price.services"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CTextBlock from '~/components/blocks/textBlock/CTextBlock.vue';
import './styles.scss';
import type { BlockPricesItem } from '~/types/pages';
import CPriceItemBlock from '~/components/blocks/pricesBlock/CPriceItemBlock.vue';

interface Props {
  title: string;
  text: string;
  prices: BlockPricesItem[];
}

defineProps<Props>();
</script>

<style scoped></style>
